import { createTheme } from '@material-ui/core/styles';
import { v3StyleGuideTheme } from '../../../theme';

export const theme = createTheme(v3StyleGuideTheme);

export const RELATIVE_POSITION = {
  header_SideBar: '125px'
};
